import styled from "styled-components";
export const Container = styled.div`
  margin-top: 40px;

  .ant-card-body {
    padding: 12px 24px;
  }
`;
